//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '@/containers-m/Navigation';

//styles
import { Layout, PageWrapper, ContainerStyled } from './ThankYou.styles';

import { Paragraph2, Title2 } from '@/components/Text';
import { MirandaBrandButton } from '@/components/Button';

const Default = () => {
  return (
    <PageWrapper>
      <Navigation />
      <Layout>
        <ContainerStyled>
          <Title2>Thank You,</Title2>
          <Paragraph2>we’ll be in touch soon.</Paragraph2>
          <br />
          <MirandaBrandButton as="a" href="/">
            Return to the homepage
          </MirandaBrandButton>
        </ContainerStyled>
      </Layout>

      <Footer />
    </PageWrapper>
  );
};

export default Default;
export { Default };
